import { z } from "zod";
import { UserInvites } from "./user-invite";
import { BillingIntervalSchema, CardSchema, InternalStatusSchema, ProductCodeSchema } from "../billing";
import { slugRegex } from "../utils/validation";
import { SsoProvider } from "./sso-provider";
import { NpmRegistryConfig } from "./npm-registry-settings";
import { WorkspaceIpSettings } from "./workspace";

const WORKSPACE_NAME_MIN_LENGTH: number = 2;
const WORKSPACE_NAME_MAX_LENGTH: number = 64;
export const HANDLE_MIN_LENGTH = 2;
export const HANDLE_MAX_LENGTH = 64;

export const CreateWorkspaceInput = z.object({
  name: z.string().min(WORKSPACE_NAME_MIN_LENGTH).max(WORKSPACE_NAME_MAX_LENGTH).trim(),
  handle: z
    .string()
    .regex(slugRegex)
    .min(HANDLE_MIN_LENGTH)
    .max(HANDLE_MAX_LENGTH)
    .refine(value => value?.length > 0)
    .optional(),
});

export type CreateWorkspaceInput = z.infer<typeof CreateWorkspaceInput>;
